import { toast } from 'react-toastify';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { Form } from 'react-bootstrap';

import "./addTeacher.css";
import { clearData } from '../../../utils/localStorage';
import SideBar from "../../commanComponents/sidebar/sidebar";
import InputDropdown from '../../commanComponents/inputDropdown/inputDropdown';
import TextInputField from '../../commanComponents/textInputField/textInputField';
import { sidebarNavItems, genderList, ROUTES, MESSAGE } from "../../../constant";
import TopNavigation from "../../commanComponents/topNavigation/topNavigation";
import PrimaryButton from '../../commanComponents/primaryButton/primaryButton';
import { getCountryService, getStateService, getCityService, saveTeacherService } from '../../../modules/services';


const AddTeacher = (props) => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [countryData, setCountryData] = useState([]);
    const [stateData, setStateData] = useState([]);
    const [cityData, setCityData] = useState([]);

    const loginSchema = z.object({
        //first_name
        first_name: z.string().min(1, { message: MESSAGE.REQUEIRED_THIS_FIELD.replace("{0}", "First Name") }),
        //last_name
        last_name: z.string().min(1, { message: MESSAGE.REQUEIRED_THIS_FIELD.replace("{0}", "Last Name") }),
        //email
        email: z.string().min(1, { message: MESSAGE.REQUEIRED_THIS_FIELD.replace("{0}", "Email") }).email({ message: MESSAGE.EMAIL_INVALID }),
        //dob
        dob: z.string(),
        //gender
        gender: z.string().min(1, { message: MESSAGE.REQUEIRED_THIS_FIELD.replace("{0}", "Gender") }),
        //phone
        phone: z.string(),
        //pincode
        pincode: z.string(),
        //country
        country: z.string(),
        //state
        state: z.string(),
        //city
        city: z.string(),
    });
    
    const { register, handleSubmit, control, formState: { errors }, getValues } = useForm({
        resolver: zodResolver(loginSchema)
    });

    const renderDropdownListData = (listData, label, value, id) => {
        return(listData.map(data => ({label: data[label], value: data[value], id: data[id]})))
    }

    const getCityDataService = (state) => {
        try {
            getCityService({ state: state })
                .then((res) => {
                    setCityData(renderDropdownListData(res.data.data, "city", "city", "id"));
            
                }).catch((error) => {
                    toast.error(error.response.data.message[0], {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                })
        } catch (error) {
            toast.error(error.response.data.message[0], {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    };

    const getStateDataService = (country) => {
        try {
            getStateService({ country_id: country })
                .then((res) => {
                    const stateList = renderDropdownListData(res.data.data, "name", "name", "id");
                    setStateData(stateList);
            
                }).catch((error) => {
                    toast.error(error.response.data.message[0], {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                })
        } catch (error) {
            toast.error(error.response.data.message[0], {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    };

    const getCountryDataService = () => {
        try {
            getCountryService({})
                .then((res) => {
                    const countryList = renderDropdownListData(res.data.data, "name", "name", "id");
                    setCountryData(countryList);
                }).catch((error) => {
                    toast.error(error.response.data.message[0], {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                })
        } catch (error) {
            toast.error(error.response.data.message[0], {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    };

    useEffect(() => { 
        getCountryDataService();
    }, []);

    const handleCountryChange = (country) => {
        getStateDataService(countryData.filter(option => option.value === country)[0].id);
    }

    const handleStateChange = (state) => {
        getCityDataService(stateData.filter(option => option.value === state)[0].id);
    }

    const handleAddMentorSave = (data) => { 
        setIsLoading(true);
        data = Object.fromEntries(
            Object.entries(data).map(([key, value]) => [key, value === '' ? null : value])
        );

        (async () => {
            const responseData = await saveTeacherService(data, {});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                setIsLoading(false);
                navigate(ROUTES.ADMIN_TEACHERS);
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                navigate(ROUTES.LOGIN);
            }
        })();
    }

    return (
        <div className='add-mentor-container' style={{ display: 'flex' }}>
            <SideBar activeItem={sidebarNavItems.adminTeachers} />
            <div className='add-mentor-side-container'>
                <TopNavigation activeItem={sidebarNavItems.adminTeachers} />
                
                <div className='row add-mentor-filter-container'>
                </div>
                
                <div className='add-mentor-main-container'>
                    <Form onSubmit={handleSubmit(handleAddMentorSave)}>
                        <div className='row'>
                            <div className='col'>
                            <h5>Add Teacher</h5>
                            </div>
                            <div className='col add-mentor-header-right'>
                                <PrimaryButton
                                    isLoading={isLoading}
                                    text="SAVE"
                                />
                            </div>
                        </div>
                        
                        <hr className="add-mentor-border" />
                        <div className='row add-mentor-input-row'>
                            <div className='col-sm'>
                                <TextInputField
                                    placeholder="First name"
                                    fieldType="text"
                                    errorMessage={errors.first_name?.message}
                                    inputKey="first_name"
                                    maxWidth="400px"
                                    formRegister={register}
                                />
                            </div>
                            <div className='col-sm'>
                                <TextInputField
                                    placeholder="Last name"
                                    fieldType="text"
                                    errorMessage={errors.last_name?.message}
                                    inputKey="last_name"
                                    maxWidth="400px"
                                    formRegister={register}
                                />
                            </div>
                        </div>
                        <div className='row add-mentor-input-row'>
                            <div className='col-sm'>
                                <TextInputField
                                    placeholder="Email"
                                    fieldType="text"
                                    errorMessage={errors.email?.message}
                                    inputKey="email"
                                    maxWidth="400px"
                                    formRegister={register}
                                />
                            </div>
                            <div className='col-sm'>
                                <TextInputField
                                    placeholder="Date of Birth"
                                    fieldType="date"
                                    errorMessage={errors.dob?.message}
                                    inputKey="dob"
                                    maxWidth="400px"
                                    formRegister={register}
                                />
                            </div>
                        </div>
                        <div className='row add-mentor-input-row'>
                            <div className='col-sm'>
                                <InputDropdown
                                    inputKey="gender"
                                    itemList={genderList}
                                    maxWidth="400px"
                                    placeholder="Gender"
                                    defaultValue={""}
                                    formRegister={control}
                                    errorMessage={errors.gender?.message}
                                />
                            </div>
                            <div className='col-sm'>
                                <TextInputField
                                    placeholder="Phone Number"
                                    fieldType="text"
                                    errorMessage={errors.phone?.message}
                                    inputKey="phone"
                                    maxWidth="400px"
                                    formRegister={register}
                                />
                            </div>
                        </div>
                        <div className='row add-mentor-input-row'>
                            <div className='col-sm'>
                                <InputDropdown
                                    inputKey="country"
                                    itemList={countryData}
                                    maxWidth="400px"
                                    placeholder="Country"
                                    defaultValue={""}
                                    formRegister={control}
                                    errorMessage={errors.country?.message}
                                    onDropdownChange={handleCountryChange}
                                />
                            </div>
                            <div className='col-sm'>
                                <InputDropdown
                                    inputKey="state"
                                    itemList={stateData}
                                    maxWidth="400px"
                                    placeholder="State"
                                    defaultValue={""}
                                    formRegister={control}
                                    errorMessage={errors.state?.message}
                                    onDropdownChange={handleStateChange}
                                />
                            </div>
                        </div>
                        <div className='row add-mentor-input-row'>
                            <div className='col-sm'>
                                <InputDropdown
                                    inputKey="city"
                                    itemList={cityData}
                                    maxWidth="400px"
                                    placeholder="City"
                                    defaultValue={""}
                                    formRegister={control}
                                    errorMessage={errors.city?.message}
                                />
                            </div>
                            <div className='col-sm'>
                                <TextInputField
                                    placeholder="Pincode"
                                    fieldType="text"
                                    errorMessage={errors.pincode?.message}
                                    inputKey="pincode"
                                    maxWidth="400px"
                                    formRegister={register}
                                />
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    );
 }


export default AddTeacher;
